import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.HierarchyTableView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'hierarchy_table'
  chartClass: 'hierarchy_table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]

  initialize: (@options = {}) ->
    @columns = ['Temática', '#menciones en el periodo', '#menciones benchmark', 'Anual']

  render: ->
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @addHierarchy()
    return this

  addHierarchy: ->
    @specific_settings ||= {}
    @specific_settings.benchmark = true
    query = _.extend({ just_first_level: true, anual_benchmark: true }, @extendedQuery({labels: @options.settings.accountLabel.codes}), @getExtraQuery())
    @setBenchmarkSettingsIfNecessary(query)
    @includedNodes = _.union( (@options.settings.includedNodes || []), (@specific_settings.includedNodes || []) )
    $.post(@options.chartApi.hierarchy, query, (response) =>
      tags = response.levels
      tags = _.filter(tags, (tag) => tag.name in @includedNodes) if @includedNodes.length > 0
      tags = _.sortBy(tags, (tag) -> -tag.y)
      tableData = { columns: @columns, data: [], types: ['string', 'string', 'number', 'number'], options: {} }
      @chartReady('.hierarchy_table')
      for tag in tags
        benchmarkCount = _.find(response.benchmark_data || [], (data) -> data.name == tag.name)?.y || 0
        totalOfTheYear = (_.find(response.anual_data || [], (data) -> data.name == tag.name)?.y) || 1
        totalOfTheYear = if totalOfTheYear == 0 then 1 else totalOfTheYear
        anualPercentage = Math.round((tag.y / totalOfTheYear).toFixed(2) * 100)
        if tag.y && benchmarkCount
          benchmarkCount = if benchmarkCount == 0 then 1 else benchmarkCount
          variancePercentage = Math.round(((tag.y-benchmarkCount)*100)/benchmarkCount)
          if variancePercentage >0
            variancePercentage = ' (+' +variancePercentage+ '%⇧)'
          else
            if variancePercentage < 0
              variancePercentage = ' (' +variancePercentage+ '%⇩)'
            else
              variancePercentage = ''
        tableData.data.push([tag.name, String(_formatNumber(tag.y) + variancePercentage) || '0', benchmarkCount, anualPercentage])
      @$el.find('.hierarchy_table').html(new Monitoring.Reports.Executive.TableView(response: tableData, table_styles: {3: { suffix: '%' }}).render().el)
    )

    _formatNumber = (n) ->
      n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
